import type { ReactNode } from 'react';
import {
  Route,
  Navigate,
} from 'react-router';
import ApiKeyList from '#features/api-access/ApiKeyList';
import AddonList from '#features/marketplace/AddonList';
import AddonDetail from '#features/marketplace/AddonDetail';
import InvoiceDetail from '#features/invoice/Detail';
import { EnsureRoleRoute } from '#bootstrap/utils';
import { USER_ROLES } from '#common/constants';
import RequestPasswordReset from '#features/auth/RequestPasswordReset';
import PasswordReset from '#features/auth/PasswordReset';

import type { PanelItem } from '#addons/types';

import Layout from './pages/Layout';
import UserHome from './pages/Home';
import AdminLayout from './pages/AdminLayout';
import UserCustomers from './pages/Customers';

// TODO
function NoMatch() {
  return (<div>not match</div>);
}

class Bootstrap {
  customer: ReactNode[];

  admin: ReactNode[];

  panel: PanelItem[];

  initialized: boolean;

  cached: {
    composedRoute: ReactNode[] | null;
    composedPanel: PanelItem[] | null;
  };

  constructor() {
    this.customer = [];
    this.admin = [];
    this.panel = [];
    this.initialized = false;
    this.cached = {
      composedRoute: null,
      composedPanel: null,
    };
  }

  composeRoute() {
    this.initialized = true;
    if (!this.cached.composedRoute) {
      this.cached.composedRoute = [
        <Route
          key="route-customer"
          element={<Layout />}
        >
          <Route
            index
            element={(
              <EnsureRoleRoute roles={[USER_ROLES.CUSTOMER]}>
                <UserHome />
              </EnsureRoleRoute>
            )}
          />
          <Route
            index
            element={(
              <EnsureRoleRoute roles={[USER_ROLES.CUSTOMER]}>
                <UserHome />
              </EnsureRoleRoute>
            )}
          />
          <Route
            path="customers"
            element={(
              <EnsureRoleRoute roles={[USER_ROLES.CUSTOMER]}>
                <UserCustomers />
              </EnsureRoleRoute>
            )}
          />
          {this.customer}
        </Route>,

        <Route
          key="route-admin"
          path="management"
          element={<AdminLayout panel={this.composePanel()} />}
        >
          <Route
            path=""
            element={(<Navigate to="marketplace/list" />)}
          />

          <Route
            path="marketplace"
          >
            <Route
              index
              element={(
                <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
                  <AddonList />
                </EnsureRoleRoute>
              )}
            />
            <Route
              path="list"
              element={(
                <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
                  <AddonList />
                </EnsureRoleRoute>
              )}
            />
            <Route
              path="detail"
              element={(
                <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
                  <AddonDetail />
                </EnsureRoleRoute>
              )}
            />
          </Route>

          <Route
            key="route-admin-api-access"
            path="api-access"
          >
            <Route
              index
              element={(
                <EnsureRoleRoute roles={USER_ROLES.ADMIN_ONLY}>
                  <ApiKeyList />
                </EnsureRoleRoute>
              )}
            />
            <Route
              path="list"
              element={(
                <EnsureRoleRoute roles={USER_ROLES.ADMIN_ONLY}>
                  <ApiKeyList />
                </EnsureRoleRoute>
              )}
            />
          </Route>

          {this.admin}
        </Route>,

        <Route
          key="route-invoice-export"
          path="invoice-export"
          element={(
            <InvoiceDetail />
          )}
        />,
        <Route
          key="route-request-password-reset"
          path="request-password-reset"
          element={<RequestPasswordReset />}
        />,
        <Route
          key="route-password-reset"
          path="reset-password/:token"
          element={<PasswordReset />}
        />,

        // TODO use redirect rather than 404 page
        <Route key="not-found" path="*" element={<NoMatch />} />,
      ];
    }

    return this.cached.composedRoute;
  }

  composePanel() {
    this.initialized = true;
    if (!this.cached.composedPanel) {
      this.cached.composedPanel = [
        ...this.panel,
        {
          label: 'SWM Marketplace',
          children: [{
            label: 'Addons',
            link: '/management/marketplace/list',
            linkAlias: ['management/marketplace'],
          }],
          roles: USER_ROLES.ADMIN_ONLY,
        },
      ];
    }

    return this.cached.composedPanel;
  }
}

export const bootstrap = new Bootstrap();
